export var getDisplayPrice = function getDisplayPrice(price, currencyCode) {
  return price.toLocaleString('es-ES', {
    style: 'currency',
    currency: currencyCode,
    currencyDisplay: 'symbol',
    maximumFractionDigits: 2
  });
};